import { render, staticRenderFns } from "./MobileSurway.vue?vue&type=template&id=bd63ba4c&scoped=true"
import script from "./MobileSurway.vue?vue&type=script&lang=js"
export * from "./MobileSurway.vue?vue&type=script&lang=js"
import style1 from "./MobileSurway.vue?vue&type=style&index=1&id=bd63ba4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd63ba4c",
  null
  
)

export default component.exports